import { Modal, ModalContent, ModalHeader } from '@grupoboticario/flora-react';
import { isMobile } from 'core/use-cases/app/helpers';
import { Carousel } from 'ui/components/compounds';

import { CarouselModalStyles } from './CarouselModal.styles';

type CarouselProps = {
  imgs: string[];
  open: boolean;
  closeModal: () => void;
  selectedImageIndex: number;
  name?: string;
};

export const CarouselModal = ({
  imgs,
  open,
  closeModal,
  selectedImageIndex,
  name = '',
}: CarouselProps) => {
  const reorderImgs = (imgs: string[], selectedImageIndex: number) => {
    const firstPart = imgs.slice(selectedImageIndex);
    const secondPart = imgs.slice(0, selectedImageIndex);

    return firstPart.concat(secondPart);
  };

  const images = reorderImgs(imgs, selectedImageIndex);
  return (
    <>
      {isMobile() ? (
        <Modal open={open}>
          <ModalContent size="large">
            <ModalHeader>
              <CarouselModalStyles.CloseButton onClick={closeModal} />
            </ModalHeader>

            <CarouselModalStyles.Body>
              <Carousel.Container container={true} desktop={false} dots={false} navigationSize="sm">
                {images.map((image, index) => (
                  <Carousel.Slide key={`product-${image}-${index}`}>
                    <CarouselModalStyles.FluidMobile>
                      <img src={image} alt={`Imagem ${index + 1} do produto ${name}`} />
                    </CarouselModalStyles.FluidMobile>
                  </Carousel.Slide>
                ))}
              </Carousel.Container>
            </CarouselModalStyles.Body>
          </ModalContent>
        </Modal>
      ) : (
        <Modal open={open}>
          <ModalContent
            isFull={isMobile() ? false : true}
            css={{
              background: 'transparent',
            }}
          >
            <ModalHeader>
              <CarouselModalStyles.CloseButton onClick={closeModal} />
            </ModalHeader>

            <CarouselModalStyles.Body>
              <Carousel.Container container={true} desktop={false} dots={false} navigationSize="lg">
                {images.map((image, index) => (
                  <Carousel.Slide key={`product-${image}-${index}`}>
                    <CarouselModalStyles.Fluid>
                      <img src={image} alt={`Imagem ${index + 1} do produto ${name}`} />
                    </CarouselModalStyles.Fluid>
                  </Carousel.Slide>
                ))}
              </Carousel.Container>
            </CarouselModalStyles.Body>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};
